import type { IHeroImage } from "InterfacesTypes/interfaces";
import { getEnvironment } from "utils/utils";

const PermissionsBanner = ({
  topImageObject,
}: {
  topImageObject?: IHeroImage;
}) => {
  const env = getEnvironment();
  return (
    <a className="w-full!" href={topImageObject?.Link}>
      <div className="overflow-hidden !w-full !h-32 group !mb-1 relative !mx-auto">
        <img
          src={`${env.imageUrl}${topImageObject?.ImageUrl}`}
          alt={topImageObject?.ImageText}
          className="!w-full h-full object-cover object-center transform transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-black/50 transition-opacity duration-300 group-hover:opacity-0"></div>
        <span className="absolute left-1/2 top-[50%] -translate-x-1/2 -translate-y-1/2 !text-white text-2xl hover:!underline">
          {topImageObject?.ImageText}
        </span>
      </div>
    </a>
  );
};
export default PermissionsBanner;
